function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import { DefaultText } from './Paragraph';
const ValidationSummary = ({
  errorMessage,
  ...rest
}) => {
  const theme = useTheme();
  if (!errorMessage) {
    return null;
  }
  return /*#__PURE__*/React.createElement(DefaultText, _extends({
    margin: 4,
    textAlign: "justify",
    color: theme.palette.error.main
  }, rest), errorMessage);
};
export { ValidationSummary };